import { type ReactNode, createContext } from "react";

import { otpOverlay } from "./ui/otp-overlay";
import { securityOverlay } from "./ui/security-overlay";
import { totpOverlay } from "./ui/totp-overlay";
import { transactionVerifyOverlay } from "./ui/transaction-verify-overlay";

type Props = {
  children: ReactNode;
} & TwoFaContext;

type TwoFaContext = {
  onGoToKybVerify: () => Promise<void>;
  onGoToKycVerify: () => Promise<void>;
  onGoToOffer: () => Promise<void>;
  onGoToPhoneVerify: () => Promise<void>;
  onGoToPolicies: () => Promise<void>;
  onGoToQuestionnaire: () => Promise<void>;
  onGoToTwoFaVerify: () => Promise<void>;
};
export const context = createContext<TwoFaContext | null>(null);

export const TwoFaConnector = ({
  children,
  onGoToKybVerify,
  onGoToKycVerify,
  onGoToOffer,
  onGoToPhoneVerify,
  onGoToPolicies,
  onGoToQuestionnaire,
  onGoToTwoFaVerify,
}: Props) => {
  return (
    <context.Provider
      value={{
        onGoToKybVerify,
        onGoToKycVerify,
        onGoToOffer,
        onGoToPhoneVerify,
        onGoToPolicies,
        onGoToQuestionnaire,
        onGoToTwoFaVerify,
      }}
    >
      <totpOverlay.Viewport />
      <securityOverlay.Viewport />
      <otpOverlay.Viewport />
      <transactionVerifyOverlay.Viewport />
      {children}
    </context.Provider>
  );
};
